module.exports = __webpack_public_path__ + "img/audio_classify4.7c5e0913.png";